import { InterfaceVariants } from 'src/constants/interface-variants';
import { CollectionChannel } from 'src/gql/graphql';

export const COLLECTION_CHANNELS_FLAG = 'growth.ecomm-admin.collection-channels.rollout';

/** Variant -> channel mapping, unflagged. */
export function getChannelFromVariant(variant?: InterfaceVariants): CollectionChannel {
  if (variant === InterfaceVariants.kiosk) {
    return CollectionChannel.kiosk;
  }

  if (variant === InterfaceVariants.mobileEcomm) {
    return CollectionChannel.mobile;
  }

  return CollectionChannel.web;
}

export function getCollectionChannel(
  variant?: InterfaceVariants,
  isCollectionChannelsEnabled = false
): CollectionChannel | undefined {
  if (!isCollectionChannelsEnabled) {
    return undefined;
  }

  return getChannelFromVariant(variant);
}

export function getCollectionChannelFromPath(
  path = '',
  isCollectionChannelsEnabled = false
): CollectionChannel | undefined {
  const pathname = path.split('?')[0];

  if (pathname.startsWith('/kiosks/')) {
    return getCollectionChannel(InterfaceVariants.kiosk, isCollectionChannelsEnabled);
  }

  if (pathname.startsWith('/mobile-ecomm/')) {
    return getCollectionChannel(InterfaceVariants.mobileEcomm, isCollectionChannelsEnabled);
  }

  return getCollectionChannel(InterfaceVariants.dutchieMain, isCollectionChannelsEnabled);
}
